import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const ExamsTableLazy = React.lazy(
	() =>
		import(
			/* webpackChunkName : 'StudentProfileExams' */ './components/ExamsTable'
		)
);

export default () => ({
	path: 'exams',
	element: <AsyncLoading component={<ExamsTableLazy />} />,
});
